import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getTimelines } from "../../store/actions/investment/getTimelines";
import TimelineTable from "./TimelineTable";
import CustomButton from "../../components/Buttons/Button";
import TimelineModal from "../../components/modal/TimelineModal";

const Timelines = () => {
  const dispatch = useDispatch();
  const [showtimelineModal, setTimelineModal] = useState(false);
  useEffect(() => {
    dispatch(getTimelines({}));
  }, []);

  return (
    <DashboardLayout>
      <div className="px-4 md:px-8">
        <div className="flex items-center mb-4 md:flex-row md:items-center w-full">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-1" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-1" />

          <div className=" font-semibold text-[#475467] text-sm sm:text-base bg-[#F9FAFB] p-1 px-3 rounded-md  ">
            Timeline Management
          </div>
        </div>

        <div className="">
          <div className="flex  justify-end items-center border-b border-b-[EAECF0] md:items-center mb-10">
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children="Create a New Timeine"
              width="256px"
              height="45px"
              padding="10px"
              margin="15px 0"
              color="#fff"
              onClick={() => {
                setTimelineModal({ type: "CREATE" });
              }}
            />
          </div>
          <div className="mt-6">
            <TimelineTable setTimelineModal={setTimelineModal} />
          </div>
          {showtimelineModal ? (
            <TimelineModal
              type={showtimelineModal?.type}
              timeline={showtimelineModal?.timeline}
              setTimelineModal={setTimelineModal}
              onClose={() => setTimelineModal(false)}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};
export default Timelines;
